/** Una línea en toolbar cuando el centro no tiene bodega RESPEL. */
export const RESPEL_NO_WAREHOUSE_ALERT_COPY = 'Centro sin bodega respel';

/** Tooltip / contexto más detallado (no se muestra en el banner). */
export const RESPEL_NO_WAREHOUSE_DETAIL_COPY =
	'Este centro no tiene una bodega RESPEL asociada. Sin bodega no puede registrar ingresos directos ni ver stock consolidado RESPEL para este centro. Configure una bodega con tipo de uso RESPEL vinculada al establecimiento.';
